import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './EditMemberModal.css';

const EditMemberModal = ({ open, handleClose, member, handleUpdate }) => {
  const [editedMember, setEditedMember] = useState({});

  useEffect(() => {
    if (member) {
      setEditedMember(member);
    }
  }, [member]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // If FeesStatus is changed to 'clear', automatically set PendingFees to 0
    if (name === 'FeesStatus' && value === 'clear') {
      setEditedMember(prev => ({ ...prev, [name]: value, PendingFees: 0 }));
    } else {
      setEditedMember(prev => ({ ...prev, [name]: value }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleUpdate(editedMember);
    handleClose();
  };

  if (!member) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-member-modal"
      aria-describedby="modal-to-edit-member-details"
    >
      <Box className="modal-container">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className="close-button"
        >
          <CloseIcon />
        </IconButton>
        <h2 id="edit-member-modal">Edit Member</h2>
        <form onSubmit={onSubmit} className="edit-form">
          <TextField
            fullWidth
            margin="normal"
            label="Name"
            name="Name"
            value={editedMember.Name || ''}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Address"
            name="Address"
            value={editedMember.Address || ''}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Mobile"
            name="Mobile"
            value={editedMember.Mobile || ''}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Occupation"
            name="Occupation"
            value={editedMember.Occupation || ''}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Age"
            name="Age"
            type="number"
            value={editedMember.Age || ''}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Start Date"
            name="Startdate"
            type="date"
            value={editedMember.Startdate || ''}
            onChange={handleChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Due Date"
            name="Duedate"
            type="date"
            value={editedMember.Duedate || ''}
            onChange={handleChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Pending Fees Amount"
            name="PendingFees"
            type="number"
            value={editedMember.PendingFees || ''}
            onChange={handleChange}
            disabled={editedMember.FeesStatus === 'clear'}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Fees Status</InputLabel>
            <Select
              name="FeesStatus"
              value={editedMember.FeesStatus || 'clear'}
              onChange={handleChange}
            >
              <MenuItem value="clear">Clear</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
            </Select>
          </FormControl>
          <Button type="submit" variant="contained" color="primary" className="update-button">
            Update
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default EditMemberModal;
